import React from 'react';
import cookies from 'js-cookie';

import { Grid } from '_utils/components/Corporate/';

import InPageAnnouncement from './InPageAnnouncement';
import SiteWideAnnouncement from './SiteWideAnnouncement';
import { AnnouncementsProps } from './definitions';

const Announcements: React.FC<AnnouncementsProps> = ({ fields: { announcements = [] } }) => {
  const isInPage = announcements.some((a) => typeof a?.fields?.dismissable === 'undefined');

  const announcementComponents = announcements
    .filter((a) => (
      typeof cookies.get(`announcement-${a.id}-dismissed`) === 'undefined' && // no cookie, so render
      a?.fields?.title?.value !== '' // need at least a title
    ))
    .map((a) => {
      const fields = {
        // key: a.id,
        id: a.id,
        ...a.fields
      };

      if (isInPage) {
        return <InPageAnnouncement key={a.id} {...fields} />;
      }

      return <SiteWideAnnouncement key={a.id} {...fields} />;
    });

  if (isInPage) {
    return (
      <Grid.Container $py="24px">
        <Grid.Row $config={{ gutters: ['left', 'right'] }}>
          <Grid.Item $config={{ col: { xs: 12 }, gutters: ['left', 'right'] }}>
            {announcementComponents}
          </Grid.Item>
        </Grid.Row>
      </Grid.Container>
    );
  }

  return <React.Fragment>{announcementComponents}</React.Fragment>;
};

export default Announcements;
